import * as React from 'react';
import { HighContrastSelector, ICalloutContentStyles, IStyle, ITextFieldStyles, mergeStyles } from '@fluentui/react';
import { buttonStylingConstants, menuStylingConstants, scrollbarStylingConstants } from './StylingConstants';

const borderStyle = {
  borderWidth: 1,
  borderColor: menuStylingConstants.menuBorderColor,
  borderStyle: 'solid',
  borderRadius: '4px'
};

export const menuCalloutStyles: Partial<ICalloutContentStyles> = {
  root: {
    ...borderStyle,
    background: menuStylingConstants.menuBackgroundColor,
    borderRadius: 4,
    width: 240,
    zIndex: 100
  }
};

export const menuContainerStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  background: menuStylingConstants.menuBackgroundColor
};

export const menuContainerFlipStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column-reverse',
  background: menuStylingConstants.menuBackgroundColor,
  overflow: 'hidden'
};

const fontStyle = {
  fontFamily: buttonStylingConstants.buttonFontFamily,
  fontSize: buttonStylingConstants.buttonFontSize,
  fontWeight: buttonStylingConstants.buttonFontWeight,
  color: buttonStylingConstants.buttonColor
};

export const searchQueryStyle: Partial<ITextFieldStyles> = {
  root: {
    width: '100%',
    marginLeft: '11px',
    marginRight: '11px'
  },
  field: {
    ...fontStyle,
    padding: 0,
    selectors: {
      '::placeholder': {
        color: '#BEBBB8'
      }
    }
  },
  fieldGroup: { ...fontStyle, flex: 1, background: menuStylingConstants.menuBackgroundColor }
};

export const plusLabelStyles: React.CSSProperties = {
  ...fontStyle,
  fontWeight: 400,
  margin: 'auto'
};

const searchResultContainer: IStyle = {
  ...fontStyle,
  maxHeight: 200,
  overflowX: 'hidden',
  overflowY: 'auto',
  selectors: {
    '::-webkit-scrollbar': {
      height: 6,
      width: 6
    },
    '::-webkit-scrollbar-thumb': {
      background: scrollbarStylingConstants.scrollbarBackgroundColor,
      borderRadius: 3,
      opacity: 0,
      selectors: {
        [HighContrastSelector]: {
          background: 'windowText'
        }
      }
    },
    ':focus-within::-webkit-scrollbar-thumb, :hover::-webkit-scrollbar-thumb': {
      background: scrollbarStylingConstants.scrollbarPressedBackgroundColor,
      selectors: {
        [HighContrastSelector]: {
          background: 'windowText'
        }
      }
    }
  }
};

export const searchResultsContainerStyles = mergeStyles(searchResultContainer, {
  borderWidth: '1px 0 0',
  borderStyle: 'solid',
  borderColor: menuStylingConstants.menuBorderColor
});

export const searchResultsContainerFlipStyles = mergeStyles(searchResultContainer, {
  borderWidth: '0 0 1px',
  borderStyle: 'solid',
  borderColor: menuStylingConstants.menuBorderColor
});

export const searchResultsNoResultsLoadingLabelStyles = mergeStyles({
  padding: '10px 40px',
  color: buttonStylingConstants.buttonColor
});
